import { render } from "./WorkWeek.vue?vue&type=template&id=45b956a1"
import script from "./WorkWeek.vue?vue&type=script&lang=js"
export * from "./WorkWeek.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__